import { c } from '../../utils/tailwind-merge';
import { AlertProps } from './types';

export const Alert = ({ label, className = '' }: AlertProps) => {
  return (
    <div
      role="alert"
      className={c(
        'rounded-lg bg-grey-100 p-4 text-center text-sm text-grey-900',
        className
      )}
    >
      {label}
    </div>
  );
};
